import React, { SFC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import logoPuebla from '../../images/logoPuebla.png';

const BannerWrapper = styled.div`
    height: 100%;
    flex-shrink: 0;
`;

const StyledLink = styled(Link)`
    display: block;
    float: left;
    height: 100%;
    text-decoration: none !important;
`;

const Image = styled.img`
    max-width: 100%;
    max-height: 100%;
    padding: 8px 0;
    vertical-align: top;
`;

const Span = styled.span`
    font-size: 20px;
    font-weight: 500;
    color: #262626;
`;

export const Banner: SFC = () => (
    <BannerWrapper>
        <StyledLink to="/">
            <Image style={{filter:'grayscale(100%)'}} src={logoPuebla} />
        </StyledLink>
    </BannerWrapper>
);
